import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AuthMarketingPanel } from '@/components/layout/auth-marketing-panel';
import { LanguageSwitcher } from '@/components/shared/language-switcher';

function AuthLayout() {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-svh bg-bg-surface">
            <aside className="hidden border-e border-border-default bg-bg-page lg:flex lg:w-1/2 xl:w-[54%]">
                <AuthMarketingPanel />
            </aside>
            <main className="flex min-w-0 flex-1 flex-col">
                <div className="flex items-center justify-between gap-4 px-6 py-5 lg:px-10">
                    {/* Brand lockup from the marketing site (the same asset the
                        site itself renders). The artwork already contains the
                        wordmark, so it replaces the former icon chip + text
                        pair rather than sitting beside it. */}
                    <img
                        src="/logo-lockup.png"
                        alt={t('common.brandName')}
                        className="h-9 w-auto"
                    />
                    <LanguageSwitcher />
                </div>
                <div className="flex flex-1 items-center justify-center px-4 pb-10 sm:px-6 lg:px-10">
                    <div className="w-full max-w-md">
                        <Outlet />
                    </div>
                </div>
            </main>
        </div>
    );
}

export { AuthLayout };
